import LectureLessonListModuleListResourceModel from '../../generated/types/model/resource/LectureLessonListModuleListResourceModel';

export default class LectureLessonListModuleListResourceViewModel extends LectureLessonListModuleListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
